import { createAction } from "@reduxjs/toolkit";

export namespace ErrorActions {
  export enum ActionTypes {
    setError = "Set Error",
    clearError = "Clear Error",
  }

  export const clearError = createAction(ActionTypes.clearError);

  export const setError = createAction<Error, ActionTypes.setError>(
    ActionTypes.setError
  );

  export type ClearError = ReturnType<typeof clearError>;
  export type SetError = ReturnType<typeof setError>;

  export type Actions = ClearError | SetError;
}
